import { PropertiesSoldContainer } from '@/modules/Properties';

const PropertiesSold = (): JSX.Element => <PropertiesSoldContainer />;

export default PropertiesSold;
